(function($) {
    /**Menu**/
    function customSubMenu() {
        $(".nav-dropdown.nav-dropdown--first").each(function(index) {

            if (!$(this).find(".nav-dropdown--second").length) {
                $(this).parent().addClass("not-dropdown-second");
            }
        });

    }

    customSubMenu();

    /**Search page**/
    $('.search__form .input-group__submit').on('click', function() {
        var input_search = $(".search__form .form__input").val().replace("/", " ");
        $(".search__form .form__input").val(input_search);
    });

    /**Tooltip**/
    $(".price-tooltip, .point-tooltip").mouseover(function() {
        if ($(window).innerWidth() > 800) {
            var scrollTop = $(window).scrollTop(),
                elementOffset = $(this).offset().top,
                distance = elementOffset - scrollTop,
                tooltip = $(this).next(),
                heightTooltip = tooltip.height(),
                heightWindow = $(window).innerHeight();

            tooltip.removeClass("move-to-top");
            tooltip.removeClass("move-to-bottom");

            if (distance + heightTooltip >= heightWindow) {
                var newPosition = 0;
                //update position tooltip
                tooltip.addClass("move-to-top");
            } else if (distance <= heightTooltip) {
                tooltip.addClass("move-to-bottom");
            } else {
                tooltip.removeClass("new-position");
            }
        }
    });


    /**FOOTER**/
    $('.menu_links > h2').on('click', function() {
        var parent = $(this).parent(),
            windowWidth = window.innerWidth;

        if (windowWidth <= 800) {
            parent.toggleClass("open");
        }

    });


    /**Home page**/

    /**New product**/
    var initNewProducts = function(domElement) {
        if (domElement.length === 0) {
            return;
        }

        domElement.slick({
            dots: false,
            arrows: true,
            adaptiveHeight: false,
            mobileFirst: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            accessibility: false,
            useCSS: true,
            prevArrow: '<button title="Prev" class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><span>Prev</span><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>',
            nextArrow: '<button title="Next" class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><span>Next</span><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button>',
            responsive: [
              {
                breakpoint: 560,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 4
                }
              }
            ]

        })
    };



    /**Promotion Products**/
    var initPromotion = function(domElement) {
        domElement.find('.list-products').slick('unslick');
    };


    if ($("body").hasClass("template-index")) {
        initPromotion($('.shopify-section__promotions-product'));
        initNewProducts($('.section-new-products .list-products'));
    }


    /**Recently Viewed Item**/
    var initRecentViewed = function(domElement) {
        if (domElement.length === 0) {
            return;
        }

        domElement.slick({
            dots: false,
            arrows: true,
            adaptiveHeight: false,
            mobileFirst: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            accessibility: false,
            useCSS: true,
            prevArrow: '<button title="Prev" class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><span>Prev</span><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>',
            nextArrow: '<button title="Next" class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><span>Next</span><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button>',
            responsive: [
              {
                breakpoint: 560,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 3
                }
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 4
                }
              },
              {
                breakpoint: 1199,
                settings: {
                  slidesToShow: 5
                }
              },
              {
                breakpoint: 1349,
                settings: {
                  slidesToShow: 6
                }
              }
            ]

        })
    };

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return 1;
    };

    $(document).ready(function() {
        if ($("#recently-viewed-products").hasClass("slick-initialized")) {
            $("#recently-viewed-products").slick("unslick");
        }
        initRecentViewed($('#recently-viewed-products'));

        checkWishlistStatus();
        getWishlist();
        addWishlist();
        removeWishlist();
        if ($("body").hasClass("template-page-discount-codes")) {
            var currentPage = getUrlParameter('page');

            getDiscountList(currentPage);

        }

        //remove provine
        if ($(".address_form").length) {
            $(".address_form").find('option[value="Putrajaya"]').remove();
        }


        if ($(".review-tab-title").length) {
            $(".review-tab-title").hide();
            $(".review-tab-m").parents(".tabs__nav-item-m").hide();
        }

        $(".review-tab-title").on("click", function() {
          const detail = {
            type: 'reviewsClick',
            label: ''
          }
          dispatchEvent(detail);
          showReview(false);
        });



        checkRating();

        if ($("body").hasClass("template-product")) {
            if ($(".review-tab-title").hasClass("active")) {
                showReview(true);
            } else {
                showReview(false);
            }
        }

    });

    $(window).scroll(function() {

    });

    /**Disable Scroll on mobile**/

    function disableScroll() {
        $('.header__nav-toggle').on('touchmove', function(evt) {
            evt.preventDefault();
        });
    }

    function enableScroll() {
        $('.header__nav-toggle').off('touchmove', function(evt) {
            evt.preventDefault();
        });
    }

    $('.header__nav-toggle').on('click', function(evt) {
        checkDevice();
    });

    function checkDevice() {
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        if (windowWidth <= 1024 && $('.sidebar-nav').hasClass('sidebar-nav--open')) {
            disableScroll();
        } else {
            enableScroll();
        }
    }

    function closeMinicart() {
        if (headerSearch.hasClass('header-search--open')) {
            headerSearch.removeClass('header-search--open');
        }
        if (miniCart.hasClass('mini-cart--open')) {
            miniCart.removeClass('mini-cart--open');
        }
        if (userLink.hasClass('open')) {
            userLink.removeClass('open');
            navUser.hide();
        }

        $('.page__overlay').removeClass('page__overlay--open');

        $("body").removeClass('no-scroll');

    }

    $('.page__overlay').bind('touchstart', function(e) {
        closeMinicart();
    });

    // AA tracking button for mini cart
    $(document).on("click", '.close-minicart', function(event) {
      const detail = {
        type: 'continueShopping',
        label: 'continueShopping'
      }
      dispatchEvent(detail);
      closeMinicart();
    });
  
    $(document).on("click", '.mini-cart__buttons .button--checkout', function (event) {
      const detail = {
        type: 'proceedCheckout',
        label: 'proceedCheckout'
      }
      dispatchEvent(detail);
    });

    $(window).resize(function() {
        //    	initNewProducts($('.section-new-products .list-products'));
        initRecentViewed($('#recently-viewed-products'));

        if ($("body").hasClass("template-index")) {
            initNewProducts($('.section-new-products .list-products'));
        }
        checkDevice();
        showCodeContent(true);
        showReview(false);
    });

    /**Nav User Drop Down in Header**/
    var userLink = $('.user__link');
    var userDropdown = userLink.find('.link');
    var navUser = userLink.find('.nav-dropdown');
    var miniCart = $(".mini-cart");
    var headerSearch = $(".header-search");


    $(document).click(function(e) {

        if (!e) e = window.event;

        if ($(e.target).hasClass("nav-dropdown__link")) {
            //sub menu
            window.location.href = $(e.target).attr("href");
        } else if ($(e.target).hasClass("user__link") || $(e.target).parents(".user__link").length ||
            $(e.srcElement).parents(".user__link").length ||
            $(e.srcElement).hasClass("user__link")) {

            if (headerSearch.hasClass('header-search--open')) {
                headerSearch.removeClass('header-search--open');
            }

            if (miniCart.hasClass('mini-cart--open')) {
                miniCart.removeClass('mini-cart--open');
            }

            if (userLink.hasClass('open')) {
                userLink.removeClass('open');
                $("body").removeClass('no-scroll');
                navUser.hide();
                $('.page__overlay').removeClass('page__overlay--open');
            } else {
                userLink.addClass('open');
                $("body").addClass('no-scroll');
                navUser.show();
                $('.page__overlay').addClass('page__overlay--open');
            }
        } else if ($(e.target).hasClass("search-form") || $(e.target).parents(".search-form").length) {

            if (miniCart.hasClass('mini-cart--open')) {
                miniCart.removeClass('mini-cart--open');
            }

            if (userLink.hasClass('open')) {
                userLink.removeClass('open');
                navUser.hide();

            }
        } else {
            if ($(e.target).hasClass("page__overlay")) {
                if (headerSearch.hasClass('header-search--open')) {
                    headerSearch.removeClass('header-search--open');
                }
                if (miniCart.hasClass('mini-cart--open')) {
                    miniCart.removeClass('mini-cart--open');
                }
                if (userLink.hasClass('open')) {
                    userLink.removeClass('open');
                    navUser.hide();
                }
                $('.page__overlay').removeClass('page__overlay--open');
                $("body").removeClass('no-scroll');
            } else if ($(e.target).hasClass("mini-cart-menu") || $(e.target).parents(".mini-cart-menu").length) {
                if (headerSearch.hasClass('header-search--open')) {
                    headerSearch.removeClass('header-search--open');
                }
                if (userLink.hasClass('open')) {
                    userLink.removeClass('open');
                    navUser.hide();
                }
            }
        }

    });

    function phone_validate(phno) {
        var regexPattern = new RegExp(/^[0-9]+$/); // regular expression pattern
        return regexPattern.test(phno);
    }

    //update quantity in cart page
    $(".quantity-selector__current-quantity").keypress(function() {

        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').hide();
        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').text("");

    });

    $(".quantity-selector__current-quantity").focusout(function(event) {
        var link = $(this).attr("data-link"),
            quantity = $(this).val(),
            inventory_quantity = $(this).attr("data-inventory-quantity"),
            product_name = $(this).parents(".cart-item").find(".cart-item__title > a").text();

        inventory_quantity = parseInt(inventory_quantity);
        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').hide();
        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').text("");

        if (phone_validate(quantity) && quantity > 0) {
            if (parseInt(quantity) <= inventory_quantity) {
                $(this).parent().find('.error_Msg').hide(); // hides error msg if validation is true
                window.location.href = link + "&quantity=" + quantity;
            } else {
              if($(this).closest('[data-gift-wrap-item]').length) {
                $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').text(window.languages.gift_wrap_sold_out_message);
              }
              else {
                $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').text(window.languages.sold_out_message);
              };

                $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').css("display", "block"); // shows validation msg if validation is false
                $(this).addClass("has-error");
                event.preventDefault();
            }
        } else {
            $(this).parent().find('.error_Msg').css("display", "block"); // shows validation msg if validation is false
            $(this).addClass("has-error");
            event.preventDefault();

        }

    });

    // AA tracking
    $(".cart__items a.link").click(function (e) {
      const dataType = $(this).data('type');
      let carData = [];
      $.ajax({
        method: 'GET',
        async: false,
        url: '/cart.js',
        dataType: 'json'
      }).done(function (cart) {
        if (cart) {
          carData = cart.items;
        }
      });

      let variantValue;
      let type;
      switch(dataType) {
        case 'reduce':
          variantValue = $($(this).parents().eq(2)).data("variant-id");
          type = 'unitChangeMinus';
          break;
        case 'increase':
          variantValue = $($(this).parents().eq(2)).data("variant-id");
          type = 'unitChangePlus';
          break;
        case 'wishlist':
          variantValue = $($(this).parents().eq(1)).data("variant-id");
          if ($(this).hasClass( "wishlist_collections") && $(this).hasClass( "btn-active")) {
            type = 'favoriteRemove';
          } else {
            type = 'favoriteAdd';
          }
          break;
        case 'delete':
            variantValue = $($(this).parents().eq(1)).data("variant-id");
            type = 'unitDelete';
          break;
      }
      
      const data = carData?.find(ele => ele.variant_id == variantValue);
      console.log('data', data);
      if (data) {
        const dataDetail = {
          type: type,
          sku: data.sku,
          model: $(`input[name="model_${data.variant_id}"]`).val(),
          superModel: $(`input[name="superModel_${data.variant_id}"]`).val(),
          category: $(`input[name="sixdcode_${data.variant_id}"]`).val()
          // category: data.product_type.toString()
        };
        
        var event = new CustomEvent("cartEvent", {
          detail: dataDetail
        });
        document.dispatchEvent(event);
      }
    });

    $(".header__logo-link, .header__main-nav a.link, .nav-dropdown__item a.nav-dropdown__link").click(function () {
      let detail = {};
      if ($(this).hasClass("header__logo-link")) {
        detail = {
          type: 'headerHome',
          label: ''
        };
      } else {
        const name = $(this).attr("data-title");
        detail = {
          type: 'headerCategory',
          label: name
        };
      }
      dispatchEvent(detail);
    });

    $(`.header__link.search-form a.link, .header__link.wishlist a.link, .header__link.mini-cart-menu a.link, 
    .header__link.user__link a.nav-dropdown__link.link`).click(function () {
      let detail;
      if ($(this).attr('aria-label') === 'Search') {
        detail = {
          type: 'headerSearch',
          label: ''
        };
      } else if ($(this).attr('href') === '/pages/wishlist') {
        detail = {
          type: 'headerWishlist',
          label: ''
        };
      } else if ($(this).attr('aria-label') === 'Cart') {
        detail = {
          type: 'headerCart',
          label: ''
        };
      } else if ($(this).attr('alt') === 'Sign In') {
        detail = {
          type: 'headerSignIn',
          label: ''
        };
      } else if ($(this).attr('alt') === 'Register') {
        detail = {
          type: 'headerRegister',
          label: ''
        };
      }

      if (detail) {
        dispatchEvent(detail);
      }
    });

    $(`.fs-slideshow__nav-button.fs-slideshow__nav-prev.slick-prev[alt="Prev"], 
    .fs-slideshow__nav-button.fs-slideshow__nav-next.slick-next[alt="Next"]`).click(function () {
      let detail;
      const type = $(this).attr("alt");
      if (type === "Next") {
        detail = {
          type: 'sliderArrow',
          label: 'Next'
        };
      } else {
        detail = {
          type: 'sliderArrow',
          label: 'Previous'
        };
      }
      dispatchEvent(detail);
    });

    $('.product-item__see-more.button-wrapper, .product-item__title a[class="link"]').click(function () {
      let modelName;
      if ($(this).is('.product-item__see-more, .button-wrapper')) {
        modelName = $(this).parent().find('.product-item__info .product-item__title a[class="link"]').html();
      } else {
        modelName = $(this).html();
      }

      const detail = {
        type: 'viewDetail',
        label: modelName
      };
      dispatchEvent(detail);
    });

    $('.collection__filter.styled-select.collection-sort-by select').change(function () {
      const detail = {
        type: 'sortingClick',
        label: ''
      };
      dispatchEvent(detail);
    });

    $('.fs-slideshow__plyr-container').click(function() {
      const titleVideo = $(this).find('iframe').attr('title');
      const detail = {
        type: 'videoClick',
        label: titleVideo
      }
      dispatchEvent(detail);
    });

    $(`#shopify-section-product-template .fs-slideshow__nav-button.fs-slideshow__nav-prev.slick-prev.slick-arrow, 
    #shopify-section-product-template .fs-slideshow__nav-button.fs-slideshow__nav-next.slick-next.slick-arrow`).click(function () {
      let sliderArrow;
      const type = $(this).attr("title");
      if (type == "Prev") {
        sliderArrow = "Previous";
      } else {
        sliderArrow = "Next";
      }

      const detail = {
        type: 'sliderArrow',
        label: sliderArrow
      }
      dispatchEvent(detail);
    });

    $('.styled-select.styled-select--secondary select.single-option-selector').change(function () {
      const sizeSelect = $(this).val();
      const detail = {
        type: 'screenSize',
        label: sizeSelect
      }
      dispatchEvent(detail);
    });

    $('.product__slide-wrapper').click(function() {
      const detail = {
        type: 'carouselClick',
        label: ''
      }
      dispatchEvent(detail);
    });

    $('.quantity-selector a[data-action="increase-product-quantity"], .quantity-selector a[data-action="decrease-product-quantity"]').click(function () {
      let unitChange;
      var parent = $(this).parents('.product__details');
      if ($(this).attr('data-action') == 'increase-product-quantity') {
        unitChange = 'Plus';
      } else {
        unitChange = 'Minus';
      }

      const detail = {
        type: 'unitChange',
        label: unitChange,
        model: parent.find(`input[name^="model_"]`).val(),
        superModel: parent.find(`input[name^="superModel_"]`).val(),
        category: parent.find(`input[name^="sixdcode_"]`).val(),
      }
      dispatchEvent(detail);
    });

    $('.form__control.variant-colour .product__available-colors input[type="radio"]').change(function () {
      const color = $(this).val();
      const detail = {
        type: 'colorSwatch',
        label: color
      }
      dispatchEvent(detail);
    });

    $('body[class^="product"] li.tabs__nav-item').click(function () {
      const tabName = $(this).html().trim();
      //there was another event for Reviews
      if (tabName !== 'Reviews') {
        const detail = {
          type: 'stickynav',
          label: tabName
        };
        dispatchEvent(detail);
      }
    });

    $('.checkout-btn .button--continue-shoping').click(function () {
      const detail = {
        type: 'continueShopping',
        label: 'continueShopping'
      }
      dispatchEvent(detail);
    });

    function dispatchEvent(dataDetail) {
      // console.log('event', dataDetail);
      // debugger;
      var event = new CustomEvent("linkInteraction", {	
        detail: dataDetail	
      });	

      document.dispatchEvent(event);	
    };

    // AA tracking buynow button
    $('.product__details').on('click', '.shopify-payment-button__button', function (e) { 
      var self = $(this).parents('.product__details');
      // var elementId = self.data('id');
      // var element = $('#' + elementId);
      console.log('self', self);

      // Adobe analytics Event Addtocart
      var skuValue = self.find('input[name="sku"]').val();
      var modelValue = self.find('input[name^="model_"]').val();
      var supperModelValue = self.find('input[name^="superModel_"]').val();
      var categoryValue = self.find('input[name^="sixdcode_"]').val();
      var priceValue = self.find('input[name="single-compare-at-price"]').val();
      var discountPriceValue = self.find('input[name="single-price"]').val();
      var quantityValue = self.find('input[name^="quantity"]').val();
      if (priceValue != '') {
        priceValue = priceValue;
      } else {
        priceValue = discountPriceValue;
      }
      // var discountValue = Math.floor((priceValue - discountPriceValue) * 100 / priceValue);
      var discountValue = Math.floor((1 - (discountPriceValue / priceValue)) * 100);
      const detailItems = {
        sku: [skuValue],
        model: [modelValue],
        superModel: [supperModelValue],
        quantity: [quantityValue],
        category: [categoryValue],
        price: [Shopify.formatMoney(priceValue)],
        discount: [discountValue],
        discountprice: [Shopify.formatMoney(discountPriceValue)],
        loyaltyPoints: 0
      };
      console.log('data', detailItems);
      
      var event = new CustomEvent("buyNowClick", {
        detail: detailItems 
      });
      
      document.dispatchEvent(event);
    });
    // AA tracking buynow button

    $(".quantity-selector .increase-quantity").click(function(event) {
        var shop_link = $(".header__logo-link").attr("href");
        var link = shop_link + $(this).attr("data-link"),
            inventory_quantity = $(this).attr("data-inventory-quantity"),
            quantity = $(this).attr("data-quantity"),
            product_name = $(this).parents(".cart-item").find(".cart-item__title > a").text();
        var current_quantity = $(this).parent().find('input[name="update_quantity"]').val();

        $(this).parent().find('.error_Msg').hide();
        //     console.log(link + "---" + quantity + "--" + inventory_quantity);
        quantity = parseInt(quantity);
        inventory_quantity = parseInt(inventory_quantity);

        if (current_quantity != "" && phone_validate(current_quantity)) {
            if (current_quantity >= inventory_quantity) {
              if($(this).closest('[data-gift-wrap-item]').length) {
                $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').text(window.languages.gift_wrap_sold_out_message);
              }
              else {
                $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').text(window.languages.sold_out_message);
              };
              
                $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').css("display", "block"); // shows validation msg if validation is false
                $(this).addClass("has-error");
                event.preventDefault();
            } else if (current_quantity > 0) {
                var increase_quantity = parseInt(current_quantity) + 1;
                // console.log(shop_link + $(this).parent().find('input[name="update_quantity"]').attr("data-link") + "&quantity=" + increase_quantity);
                window.location.href = shop_link + $(this).parent().find('input[name="update_quantity"]').attr("data-link") + "&quantity=" + increase_quantity;
            } else {
                $(this).parent().find('.error_Msg').css("display", "block");
                $(this).addClass("has-error");
                event.preventDefault();
            }

        } else {
            $(this).parent().find('.error_Msg').css("display", "block");
            $(this).addClass("has-error");
            event.preventDefault();
        }

    });


    $(".quantity-selector__current-quantity").on('keyup', function(event) {
        var link = $(this).attr("data-link"),
            quantity = $(this).val();

        if (phone_validate(quantity) && quantity > 0) {
            $(this).parent().find('.error_Msg').hide(); // hides error msg if validation is true
            $(this).removeClass("has-error");

            if ((event.keyCode ? event.keyCode : event.which) == 13 && phone_validate(quantity)) {
                window.location.href = link + "&quantity=" + quantity;
            }
        } else {
            $(this).parent().find('.error_Msg').css("display", "block"); // shows validation msg if validation is false
            $(this).addClass("has-error");
            event.preventDefault();
        }


    });

    $(".cart__checkout-button").on("click", function(e) {
      e.preventDefault();

      if ($(".quantity-selector__current-quantity").hasClass("has-error")) {
        return false;
      }

      $.ajax({
        method: 'GET',
        url: '/cart.js',
        dataType: 'json'
      }).then(function(cart) {
        const skuValue = cart.items.map(element => element.sku.toString());
        const modelValue = cart.items.map(element => $(`input[name="model_${element.variant_id}"]`).val());
        const superModelValue = cart.items.map(element => $(`input[name="superModel_${element.variant_id}"]`).val());
        const categoryValue = cart.items.map(element => $(`input[name="sixdcode_${element.variant_id}"]`).val());
        // const categoryValue = cart.items.map(element => element.product_type.toString());
        const quantityValue = cart.items.map(element => element.quantity.toString());
        const discountValue = cart.items.map(element => element.total_discount.toString());
        // const priceValue = cart.items.map(element => Shopify.formatMoney(element.price.toString()));
        // const discountpriceValue = cart.items.map(element => Shopify.formatMoney(element.discounted_price.toString()));
        const priceValue = cart.items.map(element => $(`input[name="retailPrice_${element.variant_id}"]`).val());
        const discountpriceValue = cart.items.map(element => $(`input[name="sellingPrice_${element.variant_id}"]`).val());
  
        const detailItems = {
          sku: skuValue,
          model: modelValue,
          superModel: superModelValue,
          quantity: quantityValue,
          price: priceValue,
          category: categoryValue,
          discount: discountValue,
          discountprice: discountpriceValue,
          loyaltyPoints: 0
        };
  
        var event = new CustomEvent("checkoutEvent", {
          detail: detailItems 
        });
        document.dispatchEvent(event);
  
        // console.log('checkout', cart, detailItems);
        checkoutSubmit();
      });
    });

    function checkoutSubmit() {
      const ps5InputValidate = $('input[name="ps5_validate"]').val();
      console.log('checkout', ps5InputValidate);
      if($('button.cart__checkout-button').length > 0 && ps5InputValidate == 'false') {
        window.location.href = "/checkout";
      } else if($('a.cart__checkout-button').length > 0) {
        var hrefLink = $('a.cart__checkout-button').attr('href');
        window.location.href = hrefLink;
      }
    };

    $(".main-menu__links > li").click(function() {

        setTimeout(function() {
            checkDevice();
        }, 500);
    });


    function loginWishlist() {
        if ($('.customer-logout-in').length > 0) {
            $('.wishlist-modal').click(function(e) {
                var container = $(".wishlist-modal .content");

                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    $('.wishlist-modal').removeClass('wishlist-popup-wrapper');
                }
            });

            $(".wishlist_login").on("click", function(e) {
                e.preventDefault();

                $(".wishlist-modal").toggleClass('wishlist-popup-wrapper');

                $(".wishlist-modal .close-popup").on("click", function() {
                    $(".wishlist-modal").removeClass('wishlist-popup-wrapper');
                });
            });
        }
    }

    loginWishlist();

    function addWishlist() {
        if ($('.customer-logged-in').length > 0) {
            $(document).on('click', '.wishlist_collections:not(.btn-active)', function(e) {
                e.preventDefault();

                $(this).prop('disabled', true);
                $(this).addClass("btn-active");

                $(this).find(".tooltip").text(window.languages.added);
                var customer_id = $(this).attr('data-customer-id');
                var product_handle = $(this).attr('product-handle');
                var VariantId = $(this).attr('variantid');
                var parent = $(this).parents('.product-item');
                var $this = $(this);

                const detail = {
                  type: 'favoriteAdd',
                  label: 'add',
                  model: parent.find(`input[name^="model_"]`).val(),
                  superModel: parent.find(`input[name^="superModel_"]`).val()
                }
                dispatchEvent(detail);

                // console.log("VariantId=="+VariantId);

                http.post('customers/' + customer_id + '/WishlistMetafields', {
                    "handle": product_handle,
                    "variant_id": VariantId
                })
                .done(function(res) {
                    var count = $(".header__secondary-nav .wishlist__count").text();
                    count = parseInt(count);
                    var counts = count + 1;
                    $.cookie("els", counts);

                    $(".wishlist__count").text(counts);
                    $('[variantid="' + VariantId + '"]').prop('disabled', false);
                });
            });

            $(".wishlist_collections").mouseover(function() {
                if ($(this).hasClass("btn-active")) {
                    $(this).find(".tooltip").text(window.languages.removeWishlistText);
                } else {
                    $(this).find(".tooltip").text(window.languages.addWishlistText);
                }
            });
        }
    }


    function removeWishlist() {
        if ($('.customer-logged-in').length > 0) {
            $(document).on('click', '.btn-active', function(e) {
                e.preventDefault();
                $(this).prop('disabled', true);
                $(this).removeClass("btn-active");
                $(this).find(".tooltip").text(window.languages.removed);

                var customer_id = $(this).attr('data-customer-id');
                var product_handle = $(this).attr('product-handle');
                var VariantId = $(this).attr('variantid');
                var parent = $(this).parents('.product-item');
                var $this = $(this);

                const detail = {
                  type: 'favoriteRemove',
                  label: 'remove',
                  model: parent.find(`input[name^="model_"]`).val(),
                  superModel: parent.find(`input[name^="superModel_"]`).val()
                }
                dispatchEvent(detail);

                http.delete('customers/' + customer_id + '/WishlistMetafields', {
                    "handle": product_handle,
                    "variant_id": VariantId
                })
                .done(function(res) {
                    var count = $(".header__secondary-nav .wishlist__count").text();
                    count = parseInt(count);
                    var counts = count - 1;

                    $.cookie("els", counts);

                    $(".wishlist__count").text(counts);
                    $('[variantid="' + VariantId + '"]').prop('disabled', false);
                });

            });

            $(document).on('click', '.wishlist-content .grid__cell .btn-active', function(e) {
                $(this).parents(".grid__cell").remove();
            });
        }
    }

    function checkWishlistStatus() {
        if ($('.customer-logged-in').length > 0) {
            $(".wishlist_collections").each(function() {
                var $this = $(this);
                var variant_id = $this.attr("variantid");
                var customer_id = $('.header__secondary-nav .wishlist a').attr('data-customer_id');

                http.get('customers/' + customer_id + '/WishlistMetafields/' + variant_id)
                    .done(function(res) {
                        if (res.data == true) {
                            $this.addClass("btn-active");
                        }
                    });
            });
        }
    }

    function getWishlist(product) {
      if ($('.customer-logged-in').length > 0) {
        var customer_id = $('.header__secondary-nav .wishlist a').attr('data-customer_id'),
          wishlist_content = $(".wishlist-content"),
          varid = [],
          wishlist__count = $(".wishlist__count");
  
        http.get('customers/' + customer_id + '/WishlistMetafields')
          .done(function (res) {
            var data = res.data;
            var handle_arr = [];
  
            if (data != null) {
              for (let i = 0; i < data.length; i++) {
                var ProductHandle = data[i].handle;
                var Variantid = data[i].variant_id;
  
                if(!ProductHandle.includes('gift-wrap') || !ProductHandle.includes('gift-wrapping')) {
                  varid.push(Variantid);
    
                  if (jQuery.inArray(ProductHandle, handle_arr) == -1) {
                    handle_arr.push(ProductHandle);
    
                    var wishlistProductPage = $(".template-product .product__details .wishlist_collections").attr("product-handle");
    
                    if (wishlistProductPage == ProductHandle) {
                      $(".template-product .input_variants").attr("data_variants", Variantid.toString());
                    }
    
                    if (ProductHandle != null && wishlist_content.length > 0) {
                      $.get('/products/' + ProductHandle + '?view=wishlist', function (data) {
                        wishlist_content.append(data).html();
    
                      }).then(function (data) {
                        for (let k = 0; k < varid.length; k++) {
                          var n = varid[k].toString();
    
                          $(".wishlist-page .grid__cell").each(function () {
                            var $this = $(this);
                            var g = $this.attr("data-variant").toString();
    
                            if (n === g) {
                              $this.show();
                              $this.addClass("adding_wishlist");
                            }
                          });
    
                          // Start get product point in wishlist
                          var variantPrice = $('.mw-show-point[data-id=' + varid[k] + ']').attr("data-price");
    
                          if (!varid[k] || !variantPrice)
                            $('.mw-show-point[data-id=' + varid[k] + ']').html(0);
                          else {
                            http.get('products/getproductpoint?variantId=' + varid[k] + '&price=' + variantPrice)
                              .done(function (data) {
                                $('.mw-show-point[data-id=' + varid[k] + ']').html(data.Data);
                              })
                              .fail(function () {
                                $('.mw-show-point[data-id=' + varid[k] + ']').html(0);
                              });
                          }
                        }

                        $(".wishlist-content > .grid__cell:not(.adding_wishlist)").remove();
                      });
                    }
                  }
                }
              }
            }
  
            var count = varid.length;
            $(wishlist__count).text(count);
  
            $(document).on('click', '.wishlist_collections', function (e) {
              /* if($(this).hasClass("btn-active")){
                 var counts = count +=1;
                 $.cookie("els", counts);
               }else{
                 var counts = count -=1;
                 $.cookie("els", counts);
               }
               $(wishlist__count).text(counts);*/
            });
          });
  
        if ($('.template-product').length > 0) {
          $(".template-product .product__details .wishlist_collections").click(function () {
            var s = $(this).attr("variantid");
            var d = $(".product__details .input_variants").attr("data_variants");
            var wishlistarrays = d.split(",");

            if ($.inArray($(this).attr("variantid"), wishlistarrays) !== -1) {
              d = d.replace(s + ",", "").replace("," + s, "").replace(s, "");
              $(".product__details .input_variants").attr("data_variants", d);
            }
            else {
              if (d != "") {
                $(".product__details .input_variants").attr("data_variants", d + "," + s);
              }
              else {
                $(".product__details .input_variants").attr("data_variants", s);
              }
            }
          });
  
          // var selected =  $( ".product__variants .styled-select select option:selected" ).val();
          var selected = $("#sony-new-variant").val();

          $(".template-product .product__details .wishlist_collections").attr('variantid', selected);
        }
      }
    }


    function CouponCode() {
        var promotion = $("#sony-promotion"),
            ProductId = promotion.attr("productid"),
            VariantIds = $("#sony-new-variant").val(),
            ColecionIds = promotion.val(),
            CustomerId = promotion.attr("customerid"),
            CountryId = "",
            Currency = promotion.attr("currency"),
            variantSelector = $(".product__form .single-option-selector"),
            loading = "<div class='loading'><div class='header-search__spinner'></div></div>",
            use_code = $('#use-code');

        http.post('discounts', { ProductId: ProductId, VariantIds: VariantIds, ColectionIds: ColectionIds, Currency: Currency, CustomerId: CustomerId, CountryId: CountryId })
            .done(function(res) {
                var data = res.Data;
                var dataPR = "";
                for (let i = 0; i < data.length; i++) {
                    var code = data[i].code,
                        type_Code = data[i].typeCode,
                        valueGet = data[i].valueGet;
                    if (data[i].note != null) {
                        var note = " - " + data[i].note;
                    } else {
                        var note = "";
                    }
                    if (data[i].requirement != null) {
                        var requirement = " - " + data[i].requirement;
                    } else {
                        var requirement = "";
                    }

                    if (data[i].applyToOrder == true) {
                        var applyToOrder = "entire order";
                    } else {
                        var applyToOrder = "";
                    }

                    if (type_Code == "FixedAmount") {

                        var promotion = "Upto " + Shopify.formatMoney(data[i].value, window.myprice) + " off " + applyToOrder + note + requirement;

                    } else if (type_Code == "Percentage") {

                        var promotion = "Upto " + data[i].value + "% off " + applyToOrder + note + requirement;
                    } else if (type_Code == "FreeShipping") {
                        var promotion = "Free shipping";
                    } else {
                        var promotion = "BuyXGetY with " + data[i].quantityBuy + " this product(s) to get " + data[i].quantityGet + " Y in " + valueGet + " at " + data[i].value + "% off" + note + requirement;
                    }
                    var template = "<p class='use-code'>Use Code: " + code + " <span class='promotion-code'>( " + promotion + " )</span></p>";
                    dataPR += template;
                    use_code.find(".loading").remove();
                }
                use_code.html(dataPR);
            });

        variantSelector.on("change", function() {
            setTimeout(function() {
                var VariantIds = $("#sony-new-variant").val();
                use_code.html(loading);
                http.post('discounts', { ProductId: ProductId, VariantIds: VariantIds, ColectionIds: ColectionIds, Currency: Currency, CustomerId: CustomerId, CountryId: CountryId })
                    .done(function(res) {
                        var data = res.Data;
                        var dataPR = "";
                        for (let i = 0; i < data.length; i++) {
                            var code = data[i].code,
                                type_Code = data[i].typeCode,
                                valueGet = data[i].valueGet;
                            if (data[i].note != null) {
                                var note = " - " + data[i].note;
                            } else {
                                var note = "";
                            }
                            if (data[i].requirement != null) {
                                var requirement = " - " + data[i].requirement;
                            } else {
                                var requirement = "";
                            }

                            if (data[i].applyToOrder == true) {
                                var applyToOrder = "entire order";
                            } else {
                                var applyToOrder = "";
                            }

                            if (type_Code == "FixedAmount") {

                                var promotion = "Upto " + Shopify.formatMoney(data[i].value, window.myprice) + " off " + applyToOrder + note + requirement;

                            } else if (type_Code == "Percentage") {

                                var promotion = "Upto " + data[i].value + "% off " + applyToOrder + note + requirement;
                            } else if (type_Code == "FreeShipping") {
                                var promotion = "Free shipping";
                            } else {
                                var promotion = "BuyXGetY with " + data[i].quantityBuy + " this product(s) to get " + data[i].quantityGet + " Y in " + valueGet + " at " + data[i].value + "% off" + note + requirement;
                            }
                            var template = "<p class='use-code'>Use Code: " + code + " <span class='promotion-code'>( " + promotion + " )</span></p>";
                            dataPR += template;
                            use_code.find(".loading").remove();
                        }
                        use_code.html(dataPR);
                    });
            }, 70)
        })
    }

    function checkoutlink() {
      $(document).on('click', '.checkout_link', function (e) {
        $.cookie('check_out', "checkout", { expires: 1, path: '/' });
      });

      if ($.cookie('check_out') != undefined && $('.check__out').length) {
        $('body.template-customers-account').hide();
  
        window.location.href = "/cart";
        $.removeCookie('check_out', { path: '/' });
      } 
      else {
        $('body.template-customers-account').show();
      }

      $(document).on('click', '.shopify-payment-button [data-actions="buy-now"]', function (e) {
        const variantId = $(this).closest('form').find('[name="id"]').val();
  
        $.cookie('variant_id', variantId, { expires: 1, path: '/' });
      });

      if ($.cookie('variant_id') != undefined && $('.check__out').length) {
        $('body.template-customers-account').hide();
  
        window.location.href = `/cart/${$.cookie('variant_id')}:1`;
  
        $.removeCookie('variant_id', { path: '/' });
      } 
      else {
        $('body.template-customers-account').show();
      }
    }

    if ($("body").hasClass("trademark--v3")) {
        checkoutlink();
        //CouponCode();

        var locations = window.location.href;
        var locale = "";
        var language_selected = $("#language-selected").text();
        if (locations != "") {
            var url_data = locations.split("?");
            if (url_data.length > 1) {
                var temp = "";
                for (let i = 0; i < url_data.length; i++) {
                    var temp2 = url_data[i];
                    if (temp2 == "locale=th" || temp2 == "locale=en") {
                        var temp = url_data[i];
                        break;
                    } else {
                        var temp = url_data[1];
                    }
                }
                if (temp != "") {
                    var temp1 = temp.split("&");
                    if (temp1.length > 0) {
                        for (let j = 0; j < temp1.length; j++) {
                            var temp3 = temp1[j];
                            if (temp3 == "locale=th" || temp3 == "locale=en") {
                                locale = temp1[j];
                            } else {
                                locale = temp1[0];
                            }
                        }
                    }
                }
            }
        }

        /**Redirect in collection and product detail**/

        if (locale != "") {
            $("#ly-languages-switcher").each(function() {
                $(this).find("a").click(function(e) {
                    var ulr_locale = $(this).text().toLowerCase();
                    var link = locations.replace(locale, "locale=" + ulr_locale);
                    history.pushState(null, null, link);

                })
            });

            if (locale == "locale=en" && language_selected == "th") {
                //update new language
                setTimeout(function() {
                    langify.helper.saveLanguage("ly68452");
                }, 200);

            }
            if (locale == "locale=th" && language_selected == "en") {
                //update new language
                setTimeout(function() {
                    langify.helper.saveLanguage("ly68453");
                }, 200);
            }
        }

        //custom product detail
        $(".product-features .block-3column").each(function() {
            var block_3column_wrapper = $(this).html();
            $(this).html("<div>" + block_3column_wrapper + "</div>");
        });

    }

    if ($("body").hasClass("template-customers-order")) {
        /**order detail**/
        var shipping_label = $(".order__items .shipping-method").attr("data-label");

        if (shipping_label != "" && shipping_label.search("Standard shipping") != -1) {
            var shipping_label_new = shipping_label.replace("Standard shipping", window.languages.standard_shipping);
            $(".order__items .shipping-method").attr("data-label", shipping_label_new);
        }
    }

    /**Edit profile**/
    function checkUserLogin() {
        var check = false;
        var user_name = "";
        if ($(".user-dropdown__item").find(".user-logined")) {
            user_name = $(".user-dropdown__item .user-logined").attr("title");

            if (user_name != undefined && user_name != "") {
                check = true;
            }
        }

        if (check == false) {
            window.location.href = $(".header__logo-link").attr("href");
        }
    }

    /**Validate form edit**/
    if ($("body").hasClass("trademark--v3")) {
        $(".edit-profile-btn").click(function() {

            $('.form-edit-validate').validate({
                rules: {
                    'customer[first_name]': {
                        required: true,
                        maxlength: 50
                    },

                    'customer[last_name]': {
                        required: true,
                        maxlength: 50
                    },

                    'customer[email]': {
                        required: true,
                        maxlength: 50
                    },
                    'customer[phone]': {
                        required: true,
                        maxlength: 15
                    }
                },

                submitHandler: function(form) {
                    var email = $('input[name="customer[email]"]').val();
                    var postData = {
                        "id": $("#customer-id").val(),
                        "origin": "SG",
                        "country_locale": "en_SG",
                        "first_name": $("#customer-firstname").val(),
                        "last_name": $("#customer-lastname").val(),
                        "phone": $("#customer-phone").val(),
                        "email": $("#customer-email").val()
                    }

                    var btnSignUp = $('.edit-profile-btn');
                    btnSignUp.addClass('button--loading');
                    btnSignUp.prop('disabled', true);

                    http.post('customers', postData)
                        .done(function(res) {
                            if (res.status) {
                                $('.alert').removeClass("alert--error");
                                $('.alert').addClass("alert--success");
                                $('.alert__title').text(window.languages.editProfileSuccess);
                            } else {
                                $('.alert').removeClass("alert--success");
                                $('.alert').addClass("alert--error");
                                if (res.message == "Invalid phone number.") {
                                    $('.alert__title').text(window.languages.edit_phone_invalid);
                                } else {
                                    $('.alert__title').text(window.languages.edit_phone_existed);
                                }

                            }
                        })
                        .always(function(e) {
                            btnSignUp.removeClass('button--loading');
                            btnSignUp.prop('disabled', false);
                        });

                }
            });


        });

        $(".find_store__form [type='submit']").click(function() {

            $('.find_store__form').validate({
                rules: {
                    '#find-store-postcode': {
                        required: true
                    }
                },

                submitHandler: function(form) {
                    var postcode = $('#find-store-postcode').val();
                    var url = $(".find_store__form").attr("action");
                    url = url + "/?query=" + postcode;
                    window.open(url, '_blank');
                    return false;
                }
            });


        });

        $("#btnChangePassword").click(function() {
            $('.form-validate').validate({
                rules: {
                    'email': {
                        required: true,
                        email: true
                    },

                    'current_password': {
                        required: true,
                        rangelength: [8, 20]
                    },

                    'new_password': {
                        required: true,
                        rangelength: [8, 20],
                        pwcheck: "Password Valid!"
                    }
                },

                submitHandler: function(form) {
                    var postData = {
                        "id": $('#change-password input[name="customer_id"]').val(),
                        "current_password": $('#change-password input[name="current_password"]').val(),
                        "password": $('#change-password input[name="new_password"]').val()

                    }
                    var btnChangePassword = $("#btnChangePassword");
                    btnChangePassword.addClass('button--loading');
                    btnChangePassword.prop('disabled', true);

                    http.put('customers/change_pwd', postData)
                        .done(function(res) {
                            if (res.status) {
                                res.message = window.languages.change_password_success;
                                $('.reg--error').removeClass("alert--error");
                                $('.reg--error').addClass("alert--success");
                            } else {
                                $('.reg--error').show();
                                if (res.message == "Your password is incorrect.") {
                                    res.message = window.languages.change_password_wrong_pass;
                                } else if (res.message == "No account found with that email.") {
                                    res.message = window.languages.change_password_wrong_email;
                                } else if (res.message == "Password can not change.") {
                                    res.message = window.languages.change_password_fail;
                                }

                                $('.reg--error').removeClass("alert--success");
                                $('.reg--error').addClass("alert--error");
                            }
                            $('.reg--error--title').text(res.message);
                            $('.reg--error').show();
                        })
                        .always(function(e) {
                            btnChangePassword.removeClass('button--loading');
                            btnChangePassword.prop('disabled', false);
                        });

                    return false;
                }
            });

            $.validator.addMethod("pwcheck", function(value, element) {
                return /^[A-Za-z0-9\d=!\-@._#&%*]*$/.test(value) // consists of only these
                    &&
                    /[a-z]/.test(value) // has a lowercase letter
                    &&
                    /[A-Z]/.test(value) // has a uppercase letter
                    &&
                    /\d/.test(value) // has a digit
                    &&
                    /[!\-@._#&%*]/.test(value) //has one special character without space
            }, window.languages.invalid_password);



        });

        $("#money_vat").text(Shopify.formatMoney($("#money_vat").text(), window.theme.order_money));
        $("#excluded_tax").text(Shopify.formatMoney($("#excluded_tax").text(), window.theme.order_money));

    }

    /**Multi language**/

    $(".multi-language-selector >span")
        .mouseover(function() {
            $(this).parent().addClass("open");
        })
        .mouseout(function() {
            $(this).parent().removeClass("open");
        });

    $(".multi-language-selector ul")
        .mouseover(function() {
            $(this).parent().addClass("open");
        })
        .mouseout(function() {
            $(this).parent().removeClass("open");
        });

    $("#ly-languages-switcher img").click(function() {
        $(this).parent().find("a").trigger("click");
    });


    /***Delete Address***/
    $(".delete-address").click(function() {
        if (confirm(window.languages.delete_confirm)) {
            // your deletion code
            var address_id = $(this).attr("data-address-id");

            Shopify.postLink('/account/addresses/' + address_id, { 'parameters': { '_method': 'delete' } });
        } else {
            event.preventDefault();
        }

        return false;
    });
    var RecordsPerPage = 10;

    function getDiscountList(currentPage) {
      var customerId = $(".discount-list").attr('data-customer-id');

      // $(".discount-list").css("opacity", 0);
      $(".discount-list").append("<div class='loader'></div>");

      $(".discount-paging").addClass('hidden');

      var postData = {
        "customerId": customerId,
        "CountryId": "",
        "Currency": "MYR",
        "CurrentPage": currentPage,
        "RecordsPerPage": RecordsPerPage,
        "noCache": true,
      }

      http.post('discounts', postData)
        .done(function (res) {
          var data = res['discounts'];
          var totalRecords = res['totalRecords'];
          var totalPage = Math.ceil(totalRecords / RecordsPerPage);

          if (currentPage > totalPage) {
            $(".discount-list .loader").remove();
            $(".discount-list").html("<p class='no-have-data'>No have data.</p>");
          }
          else {
            if (data.length > 0) {
              var html = "";
              var icon_discount = $('.icon-tag-html').html();
              var icon_copy = $('.icon-copy-html').html();

              if (icon_discount === undefined) {
                icon_discount = "";
              }
              if (icon_copy === undefined) {
                icon_copy = "";
              }
              for (let i = 0; i < data.length; i++) {
                var note = data[i].note;
                var code_name = data[i].code;
                // var code_expire = data[i].expireDate;
                
                if (code_name !== undefined && code_name != "") {
                  html += '<div class="discount-item">';
                  html += '<ul class="discount-item-wrap">';
                  html += '<li class="code-value">CODE: ' + icon_discount;
                  html += '<span class="copy-code" data-value="' + code_name + '">' + code_name + icon_copy + "</span>";
                  html += '</li>';
                  // if (code_expire !== undefined && code_expire != "") {
                  //   html += '<li class"code-expire">Ngày hết hạn: ' + dateToYMD(code_expire) + '</li>';
                  // }

                  if (note !== undefined && note != "") {
                    // html += '<ul class="code-content">';
                    html += '<li class="note-discount">' + note + '</li>';
                    // html += '<span class="detail">Detail</span>';
                    // html += '</ul>';
                  }
                  html += '</ul>';
                  html += '</div>';
                }
              }

              $(".discount-list").html(html);

              showCodeContent();

              $(".code-content .detail").click(function (e) {
                $(this).parent().removeClass("has-more");

                if ($(this).parent().find("p").innerHeight() > 105) {
                  $(this).parent().css({ "overflow-y": "scroll", "max-height": "105px" });
                }

                $(this).remove();
              });

              // $(".discount-list").css("opacity", 1);

              $(".icon-copy").click(function (e) {
                $(".copied-text").remove();
                $(".copy-code").removeClass('copied');
                var parent = $(this).parent();
                parent.addClass("copied");
                e.preventDefault();
                var copied_text = "<span class='copied-text'>Copied</span>";

                // Select the text
                var copied;
                const el = document.createElement('textarea');
                el.value = parent.attr('data-value');
                document.body.appendChild(el);
                el.select();

                try {
                  // Copy the text
                  copied = document.execCommand('copy');
                  document.body.removeChild(el);
                }
                catch (ex) {
                  copied = false;
                }

                if (copied) {
                  parent.append(copied_text);
                  $(".copy-code").addClass('copied');
                  setTimeout(function () {
                    $(".copied-text").remove();
                    $(".copy-code").removeClass('copied');
                  }, 500);
                }
              });
            }
            else {
              $(".discount-list").html("<p class='no-have-data'>No have data.</p>");
            }
          }
          showNavigation(currentPage, totalPage);

          // $(".discount-list").css("opacity", 1);
        })
    }

    function showNavigation(currentPage, totalPage) {
      if (currentPage > totalPage || totalPage <= 1) {
        //hide navigation
        $(".discount-paging .pagination").remove();
      }
      else {
  
        //show navigation
        var html = "";
        var prev = parseInt(currentPage) - 1;
        var next = parseInt(currentPage) + 1;
        $(".pagination__prev").hide();
        $(".pagination__next").hide();
        if (currentPage > 1) {
          $(".pagination__prev").show();
          $(".pagination__prev").attr("href", "/pages/your-discount-codes?page=" + prev);
        }
        if (currentPage < totalPage) {
          $(".pagination__next").show();
          $(".pagination__next").attr("href", "/pages/your-discount-codes?page=" + next);
        }
  
  
        for (i = 1; i <= totalPage; i++) {
          if (currentPage == i) {
            html += '<li class="pagination__nav-item pagination__nav-item--active">';
            html += '<span>' + i + '</span>';
            html += '</li>';
          }
          else {
            html += '<li class="pagination__nav-item">';
            html += '<a rel="' + i + '" href="/pages/your-discount-codes?page=' + i + '" class="pagination__nav-link link"><span>' + i + '</span></a>';
            html += '</li>';
          }
  
        }
  
        if (html != "") {
          $(".pagination__nav").html(html);
        }
      }
  
      $(".discount-paging").removeClass('hidden');
  
    }

    function showCodeContent(resize = false) {
        $(".discount-item").each(function() {
            var code_content = $(this).find('.code-content > p').innerHeight();
            if (code_content > 66 && !resize) {
                $(this).find('.code-content').addClass('has-more');
                $(this).find('.code-content .detail').show();
            }
            if ($(this).find('.code-content p').innerHeight() > 105) {
                $(this).find('.code-content').css({ "overflow-y": "scroll", "max-height": "105px" });
            } else {
                $(this).find('.code-content').css({ "overflow-y": "auto", "max-height": "none" });
            }
        });
    }

    function showReview(isActive) {
        var id = setInterval(check, 1000);
        var i = 0;
        var k = 1;

        function check() {
            //       console.log(i);
            if (isActive) {
                i = 9;
            }
            if (k == 5) {
                isActive = false;
            }

            if (i >= 10) {
                clearInterval(id);
            } else {
                if ($(window).innerWidth() > 800) {
                    if (!$('#product-review-m').is(':empty')) {
                        //do something
                        var html = $("#product-review-m").html();
                        $("#product-review").html(html);
                        i = 10;
                        k++;
                        //             hideReviewPdp();
                    }
                } else {
                    if (!$('#product-review').is(':empty')) {
                        var html = $("#product-review").html();
                        $("#product-review-m").html(html);
                        i = 10;
                        k++;
                        //            hideReviewPdp();
                    }
                }
                i++;
            }
        }
    }

    /**Show review tab after clicking star**/


    window.bvCallback = function(BV) {

        BV.reviews.on('show', function() {
            if ($(window).innerWidth() > 800) {
                $('.tabs__nav-item.review-tab-title').click();

                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: $(".product__tabs").offset().top - 100
                    }, 0);

                }, 100);

            } else {
                if (!$(".tabs__nav-item-m > .review-tab-title").hasClass("active")) {
                    $('.tabs-title.review-tab-title').click();
                }

                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: $(".tabs-title.review-tab-title").offset().top - 100
                    }, 0);

                }, 100);

            }


            return false;

        });

    };


    /**Hide no review***/
    function hideNoRating() {
        $(".product-item").each(function() {

            //var inline_rating = $(this).find('[data-bv-show="inline_rating"]');
            var bv_text = $(this).find('.bv_text').text();


            if (bv_text != '' && bv_text != '(0)') {
                //         inline_rating.hide();
                $(this).find(".bv-ratings-block").addClass("show");
            }

        });


    }

    function hideReviewPdp() {
        if ($(".bv_numReviews_text").length) {
            if ($(".bv_numReviews_text").text() == '(0)') {
                //         $('[data-bv-show="rating_summary"]').hide();
                $(".review-tab-title").hide();
                $(".review-tab-m").parents(".tabs__nav-item-m").hide();
            } else {
                $(".product__meta .bv-ratings-block").addClass("show");
                $(".review-tab-title").show();
                $(".review-tab-m").parents(".tabs__nav-item-m").show();

            }

        }
    }

    function checkRating() {
        var id = setInterval(check, 1000);
        var i = 0;

        function check() {
            //       console.log("star: "+i);
            if (i >= 15) {
                clearInterval(id);
            } else {
                hideNoRating();
                hideReviewPdp();
                i++;
            }
        }
    }


    /**
     * js cateogry mobile
     */
    $(document).ready(function() {
        setWidthCategoryMobile();
        var router = new RouterRouter();
      	router.route('products/*type', productRouteCs);
    	router.route('collections/*type', productRouteCs);

        $.each($('.label._coming_soon_label'), function(index, ele){
            let btnAddToCart = $(ele).parents('.product-item').find('.product__add-to-cart');
            btnAddToCart.attr("disabled", true);
            btnAddToCart.text("Coming Soon");
            btnAddToCart.parents(".product__form").removeAttr('method action');
          })
    });

    var setWidthCategoryMobile = function() {
        var widthBrowser = $(window).width();
        if (widthBrowser < 768) {
            var categoryItem = $(".js-list-category-mobile .category-item");
            var withcategoryItem = categoryItem.width(widthBrowser * 0.21);
            $(".shopify-section__category-list-mobile").css('display', 'block');
            $(".js-list-category-mobile").width(categoryItem.length * withcategoryItem);
        } else {
            $(".js-list-category-mobile").width('auto');
        }
    }

    var productRouteCs = function(){
        $.each($('.label._coming_soon_label'), function(index, ele){
          let btnAddToCart = $(ele).parents('.grid-product-info').find('.product__add-to-cart');
          btnAddToCart.attr("disabled", true);
          btnAddToCart.text("Coming Soon");
          btnAddToCart.parents(".product__form").removeAttr('method action');
        })
        
        $relatedProduct = $('#shopify-section-related-products');
        $recommendationsProduct = $('#shopify-section-product-recommendations');
        if($relatedProduct.find('.container').length > 0 ){
          $recommendationsProduct.remove();
        }

    }

}(jQuery));
